import "./ContactUsPage.css"
import SimpleReactValidator from 'simple-react-validator';
import { useRef, useState } from 'react';
import { toast } from "react-toastify";
import { postFormData, getUser } from 'utils/service';
import Loader from 'components/elements/Loader/Loader';

const DashboardPage = (props: any) => {
  const user: any = getUser();

  const [, forceUpdate] = useState("");
  const [loading, setLoading] = useState(false);
  const [formData, SetFormData] = useState({
    name: user?.first_name+' '+user?.last_name,
    email: user?.email,
    phone_number: user?.mobile,
    message: "",
  });

  const handleChange = (e: any) => {
    SetFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const validator = useRef(
    new SimpleReactValidator({ autoForceUpdate: { forceUpdate: forceUpdate } })
  );

  const handleFormSubmit = async (e: any) => {
    e.preventDefault();
    const formValid = validator.current.allValid();
    if (formValid) {
      setLoading(true)
      let params: any = {
        name: formData.name,
        email: formData.email,
        phone_number: formData.phone_number,
        message: formData.message,
      }
      let response:any = await postFormData('feedback', params)
      if(response.success == "true"){
        validator.current.hideMessages();
        SetFormData({ ...formData, message: '' });
        toast.success(response.message)
        setLoading(false)
      }else{
        setLoading(false)
        toast.error(response.message)
      }
    } else {
      validator.current.showMessages();
    }
  }
  return (
    <div className="row row justify-content-md-center">
       
      <div className={"col-8"}>
      {loading && <Loader />}
        <div className="container contact-form">
          <div className="contact-image">
            <img src="https://image.ibb.co/kUagtU/rocket_contact.png" alt="rocket_contact" />
          </div>
          <form onSubmit={(e) => handleFormSubmit(e)}>
            <h3>Drop Us a Message</h3>
            <div className="row">
              <div className="col-md-6">
                <div className="form-group mb-3">
                  <input type="text" name="name" value={formData.name} onChange={(e) => handleChange(e)} className="form-control" placeholder="Your Name *" />
                  {validator.current.message(
                  "name",
                  formData.name,
                  "required|min:3|max:50",
                  { className: "text-danger" }
                )}
                </div>
                <div className="form-group mb-3">
                  <input type="text" name="email" value={formData.email} onChange={(e) => handleChange(e)} className="form-control" placeholder="Your Email *" />
                  {validator.current.message(
                  "username",
                  formData.email,
                  "required|email|min:6|max:50",
                  { className: "text-danger" }
                )}
                </div>
                <div className="form-group mb-3">
                  <input type="text" name="phone_number" value={formData.phone_number} onChange={(e) => handleChange(e)} className="form-control" placeholder="Your Phone Number *" />
                  {validator.current.message(
                  "phone_number",
                  formData.phone_number,
                  "required|min:10|max:12",
                  { className: "text-danger" }
                )}
                </div>
                <div className="form-group mb-3">
                  <input type="submit" name="btnSubmit" className="btn btnContact" value="Send Message" />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <textarea name="message" value={formData.message} onChange={(e) => handleChange(e)} className="form-control feedback" placeholder="Your Message *" ></textarea>
                  {validator.current.message(
                  "message",
                  formData.message,
                  "required|min:10|max:500",
                  { className: "text-danger" }
                )}
                </div>
              </div>
            </div>
          </form>
          <div className="row">
            <div className="col-12 seprator">
              <div className=" or-box">OR</div>
            </div>
            <div className="col-12">

              <div className="my-4">
                <p>Call us on: </p>
                <p>
                  <i className="fa fa-mobile" aria-hidden="true"></i> &nbsp; (+91)-9821342020
                </p>
                <p>
                  <i className="fa fa-mobile" aria-hidden="true"></i> &nbsp;  (+91)-9870942020
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DashboardPage;
